export function toSnakeCase(words, { lowerCase = false } = {}) {
  if (lowerCase) {
    words = words?.toLowerCase()
  }
  return words?.split?.(' ')?.join?.('_')
}
